import React, { useState } from 'react'
import { CheckIcon, CopyIcon } from 'lucide-react'
import { cn } from '../cn'
import { Button } from './button'

interface CodeBlockProps {
  code: string
  language?: string
  filename?: string
  className?: string
}

export function CodeBlock({
  code,
  language = 'json',
  filename,
  className,
}: CodeBlockProps) {
  const [copied, setCopied] = useState(false)

  const copyToClipboard = async () => {
    await navigator.clipboard.writeText(code)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className={cn('bg-muted/50 relative rounded-md border', className)}>
      {filename && (
        <div className='flex items-center justify-between border-b px-4 py-2'>
          <span className='text-muted-foreground text-sm font-medium'>
            {filename}
          </span>
          <Button
            variant='ghost'
            size='sm'
            onClick={copyToClipboard}
            className='h-7 w-7 p-0'
          >
            {copied ? (
              <CheckIcon className='h-4 w-4' />
            ) : (
              <CopyIcon className='h-4 w-4' />
            )}
          </Button>
        </div>
      )}
      <div className='overflow-x-auto p-4'>
        <pre className='text-sm'>
          <code className={`language-${language}`}>{code}</code>
        </pre>
      </div>
      {!filename && (
        <Button
          variant='ghost'
          size='sm'
          onClick={copyToClipboard}
          className='absolute top-2 right-2 h-7 w-7 p-0'
        >
          {copied ? (
            <CheckIcon className='h-4 w-4' />
          ) : (
            <CopyIcon className='h-4 w-4' />
          )}
        </Button>
      )}
    </div>
  )
}
